/* eslint-disable max-classes-per-file */
import { EntitiesList, EntitiesListsManager } from './entitiesLists';

class UsersList extends EntitiesList {
  loadItems() {
    return this.getUsers();
  }
  loadMoreItems() {
    return this.getUsers();
  }
  getUsers() {
    return this.appAPI.users(
      this.currentPage,
      this.itemsPerPage,
      this.searchQuery,
    );
  }
  formatResponse(response) {
    const {
      pagination,
      user_accounts: userAccounts,
    } = response;
    return {
      total: pagination.total,
      items: userAccounts.map((user) => this.entitiesFormatter.user(user)),
    };
  }
  updateUser(user) {
    const index = this.items.findIndex((item) => item.id === user.id);
    if (index > -1) {
      const newUser = this.entitiesFormatter.user(Object.assign({}, user, {
        customer_accounts: [],
      }));
      this.items[index] = newUser;
    }
  }
}

export default class UsersListsManager extends EntitiesListsManager {
  getEntitiesListClass() {
    return UsersList;
  }
}
